import {forkJoin as observableForkJoin, Observable} from 'rxjs';
import { inject } from "@angular/core";
import { ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from "@angular/router";
import {EventService} from "../services/event.service";
import {NationalTeamsService} from '../services/national-teams.service';

export const ConstituentDataResolver: ResolveFn<any> = ( route: ActivatedRouteSnapshot, state: RouterStateSnapshot ) : Observable<any>|Promise<any>|any => {

    const eventService = inject(EventService);
    const nationalTeamsService = inject(NationalTeamsService);

    const eventsObs = eventService.getConstituentEvents(route);
    const nationalTeamsObs = nationalTeamsService.reloadConstituentNationalTeams(route);
    return observableForkJoin(eventsObs, nationalTeamsObs);
}
